import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { useTranslation } from 'react-i18next'
import { getRelativeTimeString } from 'utils/dateUtil'
import { getFullDisplay } from 'utils/timeZoneUtil'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import Link from './Link'
import { useContextMediaDetail } from './context'

const DateString = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.popularMedia.postDate })<{
  mode: string
}>`
  display: flex;
  align-items: center;
  color: ${({ mode }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  font-weight: ${sys.fontWeight.regular};
`
interface DateProps {
  className?: string
  timestamp?: number
  postUrl?: string
}

const Date = ({ className, timestamp: timestampFromProp, postUrl: postUrlFromProp }: DateProps) => {
  const { t } = useTranslation()
  const displayTheme = useDisplayTheme()
  const userConfig = usePageConfigUser()
  const { timestamp: timestampFromContext, postUrl: postUrlFromContext } = useContextMediaDetail()

  const timestamp = timestampFromProp || timestampFromContext
  const postUrl = postUrlFromProp || postUrlFromContext

  return (
    <Tooltip
      mode={displayTheme}
      content={
        // eslint-disable-next-line no-nested-ternary
        !postUrl
          ? t('soundbiteNoUrl')
          : timestamp
          ? getFullDisplay(timestamp, userConfig.timeZone)
          : undefined
      }>
      <DateString mode={displayTheme} className={className}>
        <Link href={!postUrl ? undefined : postUrl}>
          {getRelativeTimeString(timestamp, userConfig.timeZone)}
        </Link>
      </DateString>
    </Tooltip>
  )
}

export default Date
